import { Link } from "react-router-dom";
import { LOGO_URL, BRAND, NAV_LINKS } from "@/lib/constants";
import {
    Instagram,
    Linkedin,
    AtSign,
    Triangle,
    Cloud,
} from "lucide-react";

const SOCIAL_ICONS = {
    Instagram,
    Linkedin,
    AtSign,
    Triangle,
    Cloud,
};

const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
};

export default function Footer() {
    return (
        <footer
            className="bg-[#fcbf49] text-[#1B1B1B] mt-20"
            data-testid="site-footer"
        >
            <div className="px-4 md:px-8 lg:px-12 py-12 grid grid-cols-1 md:grid-cols-12 gap-8">
                <div className="md:col-span-5">
                    <img
                        src={LOGO_URL}
                        alt="BENNE"
                        className="h-12 md:h-14 w-auto object-contain"
                        data-testid="footer-logo"
                    />
                    <p className="mt-4 font-sofia text-[#1B1B1B]/85 max-w-md leading-relaxed">
                        {BRAND.mission}. A press release and promotion
                        platform for those in the food space, hospitality,
                        tourism, and related events.
                    </p>
                    <div className="mt-6 flex gap-4">
                        {BRAND.socials.map((s) => {
                            const Icon = SOCIAL_ICONS[s.icon];
                            return (
                                <a
                                    key={s.name}
                                    href={s.href}
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label={s.name}
                                    className="hover:text-[#E63B26] transition"
                                    data-testid={`footer-social-${s.name.toLowerCase()}`}
                                >
                                    <Icon className="h-5 w-5" />
                                </a>
                            );
                        })}
                    </div>
                </div>
                <div className="md:col-span-3">
                    <h4 className="font-poppins font-semibold text-[#E63B26] tracking-[0.18em] uppercase text-xs">
                        Explore
                    </h4>
                    <ul className="mt-4 space-y-2 font-sofia">
                        {NAV_LINKS.map((n) => (
                            <li key={n.to}>
                                <Link
                                    to={n.to}
                                    onClick={scrollToTop}
                                    className="hover:text-[#E63B26] transition"
                                    data-testid={`footer-link-${n.to.replace(/\//g, "") || "home"}`}
                                >
                                    {n.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="md:col-span-4">
                    <h4 className="font-poppins font-semibold text-[#E63B26] tracking-[0.18em] uppercase text-xs">
                        Contact
                    </h4>
                    <Link
                        to="/contact"
                        onClick={scrollToTop}
                        className="mt-4 inline-flex items-center gap-2 font-sofia text-[#1B1B1B]/90 hover:text-[#E63B26] transition group"
                        data-testid="footer-contact-link"
                    >
                        <span className="border-b border-[#1B1B1B]/30 group-hover:border-[#E63B26]">
                            Use our contact form
                        </span>
                        <span aria-hidden="true">→</span>
                    </Link>
                    <p className="mt-3 font-sofia text-[#1B1B1B]/70 text-sm leading-relaxed">
                        One form, six topics. Press tips, partnerships,
                        billing, interviews, praises, and honest feedback all
                        go through there.
                    </p>
                </div>
            </div>
            <div className="px-4 md:px-8 lg:px-12 py-5 border-t border-[#1B1B1B]/15 flex flex-col md:flex-row items-center justify-between gap-2 text-xs font-sofia text-[#1B1B1B]/70">
                <span>© {new Date().getFullYear()} BENNE. All rights reserved.</span>
                <span className="tracking-[0.2em] uppercase">An independent publication.</span>
            </div>
        </footer>
    );
}
